import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreatePriceListMutationVariables = Types.Exact<{
  facilityId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type CreatePriceListMutation = { readonly __typename?: 'Mutation', readonly priceListV2: { readonly __typename?: 'PriceListV2Mutations', readonly createPriceList: { readonly __typename?: 'CreatePriceListResponse', readonly priceListId: string } } };


export const CreatePriceListDocument = gql`
    mutation createPriceList($facilityId: ID) {
  priceListV2 {
    createPriceList(input: {facilityId: $facilityId}) {
      priceListId
    }
  }
}
    `;
export type CreatePriceListMutationFn = Apollo.MutationFunction<CreatePriceListMutation, CreatePriceListMutationVariables>;

/**
 * __useCreatePriceListMutation__
 *
 * To run a mutation, you first call `useCreatePriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPriceListMutation, { data, loading, error }] = useCreatePriceListMutation({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useCreatePriceListMutation(baseOptions?: Apollo.MutationHookOptions<CreatePriceListMutation, CreatePriceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePriceListMutation, CreatePriceListMutationVariables>(CreatePriceListDocument, options);
      }
export type CreatePriceListMutationHookResult = ReturnType<typeof useCreatePriceListMutation>;
export type CreatePriceListMutationResult = Apollo.MutationResult<CreatePriceListMutation>;
export type CreatePriceListMutationOptions = Apollo.BaseMutationOptions<CreatePriceListMutation, CreatePriceListMutationVariables>;